import React from 'react';
import './AuthForms.css'
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import logo from '../assets/logo-mobile.png'
import axios from 'axios';
import Alert from '../Alert/Alert';
import { useAlertContext } from '../../context/alertContext';


function SignUp() {
    const { showAlert } = useAlertContext()
    const signupNavigate = useNavigate();
    const [createUser, setCreateUser] = useState({});
    const handleChangeSignUp = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setCreateUser(values => ({ ...values, [name]: value }))
    }

    function goToTop() {
        window.scroll(0, 0);
    }


    const handleSubmitSignUp = (event) => {
        event.preventDefault()
        const url = 'https://tbc-backend.up.railway.app/user/create'
        const headers = { "Content-Type": "application/json" }
        const data = {
            firstName: createUser.firstname,
            lastName: createUser.lastname,
            email: createUser.email,
            password: createUser.password,
            currentField: createUser.sector,
            niche: createUser.field,
        }

        axios.post(url, data, { headers }).then((res) => {
            showAlert('New user registered Successfully, Thanks!', 'success', '#check-circle-fill')
            setTimeout(() => {
                signupNavigate('/')
            }, 2000);
            setCreateUser({})
            goToTop()
        }).catch((err) => {
            showAlert(<div >
                <span>Failed to register! Please Enter Unique Email Id</span> <br />
                <span>(Note: Please fill all columns for register if any empty)</span>
            </div>, 'danger', '#exclamation-triangle-fill')
            goToTop()

        })
    }

    return (
        <>
            <Alert mT='20px' mR='20px' />
            <section className="form-bg mt-5 py-5 bg-white">
                <div className="container h-custom">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-md-8 col-lg-5 col-xl-5 col-11 ms-xl-5 border p-sm-5 p-2 pt-0 form-body rounded border border-dark">
                            <div className='text-center'>
                                <img className='bg-dark mt-5 img-fluid mx-auto' src={logo} alt="" />
                                <p className='pt-3 fs-5 fw-semibold'>WELCOME TO TBC EXPERTS</p>
                            </div>
                            <form onSubmit={handleSubmitSignUp}>
                                <div className="divider d-flex align-items-center my-4">
                                </div>
                                <div className="form-outline mb-4">
                                    <label className="form-label" htmlFor="firstname">
                                        First Name
                                    </label>
                                    <input
                                        type="text"
                                        id="firstname"
                                        className="form-control form-control-lg"
                                        placeholder="Enter your First Name"
                                        onChange={handleChangeSignUp}
                                        value={createUser.firstname || ""}
                                        name='firstname'
                                    />
                                </div>
                                <div className="form-outline mb-4">
                                    <label className="form-label" htmlFor="lastname">
                                        Last Name
                                    </label>
                                    <input
                                        type="text"
                                        id="lastname"
                                        className="form-control form-control-lg"
                                        placeholder="Enter your Last Name"
                                        onChange={handleChangeSignUp}
                                        value={createUser.lastname || ""}
                                        name='lastname'
                                    />
                                </div>
                                <div className="form-outline mb-4">
                                    <label className="form-label" htmlFor="email">
                                        Email address
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="form-control form-control-lg"
                                        placeholder="Enter a valid email address"
                                        onChange={handleChangeSignUp}
                                        value={createUser.email || ""}
                                        name='email'
                                    />
                                </div>
                                <div className="form-outline mb-3">
                                    <label className="form-label" htmlFor="password">
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        id="password"
                                        className="form-control form-control-lg"
                                        placeholder="Enter password"
                                        onChange={handleChangeSignUp}
                                        value={createUser.password || ""}
                                        name='password'
                                    />

                                </div>
                                <div className="form-outline mb-3">
                                    <label className="form-label" htmlFor="sector">
                                        Currecnt Field
                                    </label>
                                    <input
                                        type="text"
                                        id="sector"
                                        className="form-control form-control-lg"
                                        placeholder="Enter you current field  (eg: IT)"
                                        onChange={handleChangeSignUp}
                                        value={createUser.sector || ""}
                                        name='sector'
                                    />
                                </div>
                                <label className="form-label" htmlFor="field">
                                    Your Niche
                                </label>
                                <div className="form-outline mb-3">
                                    <input
                                        type="text"
                                        id="field"
                                        className="form-control form-control-lg"
                                        placeholder="Enter your Niche (eg: Full Stack Developer)"
                                        onChange={handleChangeSignUp}
                                        value={createUser.field || ""}
                                        name='field'
                                    />
                                </div>
                                <div className="text-center text-lg-start mt-4 pt-2">
                                    <input
                                        type="submit"
                                        className="btn btn-primary btn-lg"
                                        style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
                                        value='SignUp'

                                    />
                                    <p className="small fw-bold mt-2 pt-1 mb-0">
                                        Your have already an account?{" "}
                                        <Link to='/' className="link-danger">
                                            Log in Now
                                        </Link>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default SignUp;
